<template>
    <FormField :label="label">
        <Select v-model="model" placeholder="Required" class="tw-w-full" :disabled="disabled" required>
            <option v-for="(currency, code) in available_currencies" :key="code" :value="code">{{ currency }}</option>
        </Select>
    </FormField>
</template>
<script setup lang="ts">
import FormField from '@/js/components/widgets/FormField.vue';
import Select from '@/js/components/controls/Select.vue';
import { useDataStore } from '@/js/stores/DataStore.js';
import { storeToRefs } from 'pinia';

defineProps({
    disabled: {
        type: Boolean,
        default: false,
    },
    label: {
        type: String,
        default: null,
        required: false,
    },
});

const model = defineModel({
    type: String,
    default: null,
});

const { available_currencies } = storeToRefs(useDataStore());
</script>
